import cn from 'classnames'
import React, { ComponentProps, useId } from 'react'

export type AiAutomationRulesSvgProps = {
  className?: string
} & ComponentProps<'svg'>

export default function AiAutomationRulesSvg(props: AiAutomationRulesSvgProps) {
  const { className = '', ...rest } = props
  const documentGradientId = useId()
  const sparkleGradientId = useId()

  return (
    <svg
      className={cn('AiAutomationRulesSvg', className)}
      width="106"
      height="97"
      viewBox="0 0 106 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <rect
        width="34.9109"
        height="4.10345"
        rx="1.2069"
        transform="matrix(-1 0 0 1 38.9109 58)"
        fill="#EAEBF1"
      />
      <rect
        width="24.9109"
        height="4.10345"
        rx="1.2069"
        transform="matrix(-1 0 0 1 99.9109 25)"
        fill="#EAEBF1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.55087 0.0751048C8.55087 0.0751048 0.844992 -1.358 0.0639313 12.9905C-0.0254653 14.6328 1.32738 15.9617 2.97207 15.9617H42.8004"
        fill="#3475F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.78027 0.0434178C7.78027 0.0434178 11.4803 -0.732572 11.4803 12.331C11.4803 20.6342 11.4803 52.4387 11.4803 85.797C11.4803 90.7774 15.9183 90.7339 15.9183 90.7339L78.3597 90.7774C78.3597 90.7774 82.596 90.7774 82.596 85.2473C82.596 79.7171 82.596 12.331 82.596 12.331C82.596 12.331 82.596 0.0924234 73.2328 0.0924234C63.8695 0.0924234 7.78027 0.0434178 7.78027 0.0434178Z"
        fill={`url(#${documentGradientId})`}
      />
      <path
        d="M24.2471 13.8521H69.4506"
        stroke="#FDFFFE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M24.2471 25.9756H65.3889"
        stroke="#FDFFFE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2471 39.0318H69.3695"
        stroke="#FDFFFE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2471 64.2114H69.3695"
        stroke="#FDFFFE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M24.2471 52.0879H63.2829"
        stroke="#FDFFFE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M24.2471 77.2676H63.2829"
        stroke="#FDFFFE"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="56"
        y="47"
        width="50"
        height="50"
        rx="25"
        fill={`url(#${sparkleGradientId})`}
      />
      <path
        d="M87.3334 78.3334C87.4024 78.3334 87.4701 78.3542 87.5267 78.3937C87.5832 78.4333 87.6267 78.4897 87.6504 78.5545L87.972 79.4343C88.2252 80.1244 88.6259 80.7514 89.1456 81.2712C89.6651 81.7909 90.2913 82.1914 90.981 82.4448L91.8623 82.7664C91.9271 82.7901 91.9835 82.8336 92.0231 82.8901C92.0626 82.9467 92.0834 83.0144 92.0834 83.0834C92.0834 83.1524 92.0626 83.2201 92.0231 83.2767C91.9835 83.3332 91.9271 83.3767 91.8623 83.4004L90.981 83.722C90.2913 83.9754 89.6651 84.376 89.1456 84.8956C88.6259 85.4155 88.2252 86.0424 87.972 86.7325L87.6504 87.6123C87.6267 87.6771 87.5832 87.7335 87.5267 87.7731C87.4701 87.8126 87.4024 87.8334 87.3334 87.8334C87.2644 87.8334 87.1967 87.8126 87.1401 87.7731C87.0836 87.7335 87.0401 87.6771 87.0164 87.6123L86.6948 86.7325C86.4416 86.0424 86.0409 85.4155 85.5212 84.8956C85.0017 84.376 84.3756 83.9754 83.6859 83.722L82.8045 83.4004C82.7397 83.3767 82.6833 83.3332 82.6437 83.2767C82.6042 83.2201 82.5834 83.1524 82.5834 83.0834C82.5834 83.0144 82.6042 82.9467 82.6437 82.8901C82.6833 82.8336 82.7397 82.7901 82.8045 82.7664L83.6859 82.4448C84.3756 82.1914 85.0017 81.7909 85.5212 81.2712C86.0409 80.7514 86.4416 80.1244 86.6948 79.4343L87.0164 78.5545C87.0401 78.4897 87.0836 78.4333 87.1401 78.3937C87.1967 78.3542 87.2644 78.3334 87.3334 78.3334Z"
        fill="white"
      />
      <path
        d="M76.2501 60.9167C76.4112 60.9167 76.5679 60.9668 76.7 61.059C76.8322 61.1513 76.9337 61.2818 76.9892 61.4332L77.7406 63.4866C78.331 65.097 79.2646 66.5599 80.4775 67.7727C81.6903 68.9855 83.1532 69.9191 84.7636 70.5095L86.817 71.261C86.9683 71.3164 87.0988 71.418 87.1912 71.5501C87.2834 71.6822 87.3334 71.839 87.3334 72.0001C87.3334 72.1612 87.2834 72.3179 87.1912 72.45C87.0988 72.5822 86.9683 72.6837 86.817 72.7392L84.7636 73.4906C83.1532 74.081 81.6903 75.0146 80.4775 76.2275C79.2646 77.4403 78.331 78.9032 77.7406 80.5136L76.9892 82.567C76.9337 82.7183 76.8322 82.8488 76.7 82.9412C76.5679 83.0334 76.4112 83.0834 76.2501 83.0834C76.089 83.0834 75.9322 83.0334 75.8001 82.9412C75.668 82.8488 75.5664 82.7183 75.511 82.567L74.7595 80.5136C74.1691 78.9032 73.2355 77.4403 72.0227 76.2275C70.8099 75.0146 69.347 74.081 67.7366 73.4906L65.6832 72.7392C65.5318 72.6837 65.4013 72.5822 65.309 72.45C65.2168 72.3179 65.1667 72.1612 65.1667 72.0001C65.1667 71.839 65.2168 71.6822 65.309 71.5501C65.4013 71.418 65.5318 71.3164 65.6832 71.261L67.7366 70.5095C69.347 69.9191 70.8099 68.9855 72.0227 67.7727C73.2355 66.5599 74.1691 65.097 74.7595 63.4866L75.511 61.4332C75.5664 61.2818 75.668 61.1513 75.8001 61.059C75.9322 60.9668 76.089 60.9167 76.2501 60.9167Z"
        fill="white"
      />
      <path
        d="M90.5001 56.1667C90.5918 56.1667 90.6814 56.1949 90.7568 56.2472C90.8322 56.2997 90.8902 56.3743 90.9222 56.4605L91.352 57.6326C91.6899 58.5531 92.2235 59.39 92.9168 60.0833C93.6102 60.7767 94.4471 61.3102 95.3676 61.6481L96.5396 62.078C96.6258 62.11 96.7005 62.1679 96.753 62.2434C96.8053 62.3188 96.8334 62.4083 96.8334 62.5001C96.8334 62.5918 96.8053 62.6814 96.753 62.7568C96.7005 62.8322 96.6258 62.8902 96.5396 62.9222L95.3676 63.3521C94.4471 63.6899 93.6102 64.2235 92.9168 64.9168C92.2235 65.6102 91.6899 66.4471 91.352 67.3676L90.9222 68.5396C90.8902 68.6258 90.8322 68.7005 90.7568 68.753C90.6814 68.8053 90.5918 68.8334 90.5001 68.8334C90.4083 68.8334 90.3188 68.8053 90.2434 68.753C90.1679 68.7005 90.11 68.6258 90.078 68.5396L89.6481 67.3676C89.3102 66.4471 88.7767 65.6102 88.0833 64.9168C87.39 64.2235 86.5531 63.6899 85.6326 63.3521L84.4605 62.9222C84.3743 62.8902 84.2997 62.8322 84.2472 62.7568C84.1949 62.6814 84.1667 62.5918 84.1667 62.5001C84.1667 62.4083 84.1949 62.3188 84.2472 62.2434C84.2997 62.1679 84.3743 62.11 84.4605 62.078L85.6326 61.6481C86.5531 61.3102 87.39 60.7767 88.0833 60.0833C88.7767 59.39 89.3102 58.5531 89.6481 57.6326L90.078 56.4605C90.11 56.3743 90.1679 56.2997 90.2434 56.2472C90.3188 56.1949 90.4083 56.1667 90.5001 56.1667Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={documentGradientId}
          x1="61.9967"
          y1="90.9999"
          x2="65.6431"
          y2="-21.6412"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5FCEB6" />
          <stop offset="1" stopColor="#588AF2" />
        </linearGradient>
        <linearGradient
          id={sparkleGradientId}
          x1="64.9773"
          y1="53.4815"
          x2="151.914"
          y2="90.5661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#443FDD" />
          <stop offset="1" stopColor="#9387FC" />
        </linearGradient>
      </defs>
    </svg>
  )
}
